

function GenerativeArt(){

  const description = {

      category : {
        name : "[ generative art ]",
        description : "I'm interested in pattern, noise and form generated by computer algorithm."
      },

      project : [
        {
          title : "[ SOUND VISUALIZATION ]",

          containerColumn : '49% 40%',
          maxResourceWidth : '48%',
          tools : "Supervisor : Prof. David Hall (IDAS Korea)  - Tool : Processing, Maya, Pekakura",

          main_image : {
            "image" : require("../resources/small/soundvis_01.JPG"),
            "caption" : "Sound visualization in 3D sculpture"
          },

          description : "Sound is a crucial source of sensory information for our perception of the external world. While we primarily listen to sound through our ears, what if we could also feel, see, and touch this intangible energy? I am investigating how the brain interprets sound when it is transformed into other mediums. Does this enhance the listening experience or detract from it? To explore this, I employ processing for sound analysis, Maya for 3D object creation, and a laser cutter for paper cutting.",

            resources : [

              {
                "image" : require("../resources/small/soundvis_03.JPG"),
                "text" : "Sound visualization in 3D sculpture",
              },

              {
                "image" : require("../resources/small/soundvis_02.JPG"),
                "text" : "Sound visualization made of Newspaper",
              }
            ]
          },

          {
            "title" : "[ GENERATIVE SHAPES ]",
  
            containerColumn : '83% 20%',
            maxResourceWidth : '20%',
            tools : "Tool : openFrameworks",

            main_image : {
              "image" : null,
              "caption" : null
            },

            description : "This project expresses the essence of people's names. Our names hold memories, identities, and joy, and are unique to us. Using openFrameworks, I created a shape generator that analyzes a person's name and generates distinct shapes related to it. The first letter serves as the key value for the overall color scheme, while the other letters influence additional visual effects.​",
  
              resources : [  
  
                {
                  "image" : require("../resources/small/shape_01.png"),
                },

                {
                  "image" : require("../resources/small/shape_03.png"),
                },
  
                {
                  "image" : require("../resources/small/shape_02.png"),
                },

                {
                  "image" : require("../resources/small/shape_04.png"),
                },
              ]
            },

            {
              "title" : "[ BEAUTY OF RANDOMNESS ]",
    
              containerColumn : '83% 20%',
              maxResourceWidth : '30%',
              tools : "Tool : processing and shader",
  
              main_image : {
                "image" : null,
                "caption" : null
              },
  
              description : "I am eager to develop an algorithm for a brush and natural color composition. The beauty of randomness makes each render a thrilling moment to see.​",
    
                resources : [  
    
                  {
                    "image" : require("../resources/small/random-01.jpg"),
                  },
  
                  {
                    "image" : require("../resources/small/random-02.jpg"),
                  },
    
                  {
                    "image" : require("../resources/small/random-03.jpg"),
                  },

                ]
              },

            {
              "title" : "[ SEEING MUSIC ]",
    
              containerColumn : '83% 20%',
              maxResourceWidth : '20%',
              tools : "Supervisor : Matti Niinimäki (Aalto University)  Advisor : Nuno Correia (University of Greenwich) , Matti Niinimäki (Aalto University) - Tool : Processing",
  
              main_image : {
                "image" : null,
                "caption" : null
              },
  
              description : "Music and visual art are integral to our daily lives, influencing our emotions through their sensory experiences. This thesis explores the connection between music and generative art, specifically converting music into visual artwork through a colour theme linked to musical emotion. The project is based on an emotional model of arousal and valence and demonstrates how colour impacts our emotions. The thesis details the process of retrieving musical information, including arousal and valence, and demonstrates the implementation of software that integrates musical emotion and characteristics like frequency analysis. The result is a generative artwork that can be applied to various daily life products.",
            
              resources : [  
  
                {
                  "image" : require("../resources/small/masterthesis_01.jpg"),
                },

                {
                  "image" : require("../resources/small/masterthesis_03.jpg"),
                },
  
                {
                  "image" : require("../resources/small/masterthesis_02.jpg"),
                },

                {
                  "image" : require("../resources/small/masterthesis_04.jpg"),
                },
              ]
            

            },

            {
              "title" : "[ DRAWING MACHINE ]",

              description : `This project introduces a new type of drawing machine that can create curves and lines with a natural flow. Using Morse code, a well-known method of communication, the drawing machine will convert messages, such as "LOVE," into a visual representation. This allows the machine to express messages in a unique and creative way.`,
    
              containerColumn : "65% 35%",
              maxResourceWidth : "40%",
              tools : "Supervisor : Prof. David Hall (IDAS Korea) - Tool : Arduino , Stepper motors , Sensors, Servo motors",
  
              main_image : {
                "movie" : "mVPDrrjWDYY",
                "height" : "200%",
              },
            },

        ]

      };


  return description;
}

export default GenerativeArt;

// class GenerativeArt extends React.Component{

//     constructor(props){

//         super();

//         const description = {

//           "project_category" : {
//               "title": "Generative Art",
//               "description" : "I'm interested in pattern, noise and form generated by computer algorithm."
//           },
      
//           "project" :{
//               "title" : "[ SOUND VISUALIZATION ]",
//               "description" : "The sound is the one of most sensory information for us to recognize what's going on the outside world. This audible information is mainly focused on our ears to perceive it. Hence, My question is that what happen if we could feel,see and touch this invisible energy. I mean how can our brain interpret the sound if the sound transformed into other medium. Does it help to listen to a sound? or it interrupts to enjoy listen to a sound? In order to do that, I used processing for sound analysis, Maya for build 3D object and laser cutter for cutting paper."
//           }
//       }

//         this.myRef = React.createRef();
//         this.onScroll = this.onScroll.bind(this);
//         this.displayFullImage = this.displayFullImage.bind(this);
//     }

//     componentDidMount(){

//         window.addEventListener('scroll', this.onScroll);

//         this.scrollToMyRef();
//      }

//      getDescription(){
//        return this.description;
//      }

//      scrollToMyRef(){

//       this.myRef.current.scrollIntoView({ behavior: 'smooth'});
//     }
 
//      componentWillUnmount(){
 
//          window.removeEventListener('scroll', this.onScroll);
//      }

//     onScroll(event) {

//         console.log(window.pageYOffset + " , "+this.myRef.current.offsetTop);

//         if (Math.round(window.pageYOffset)>= this.myRef.current.offsetTop){

//             window.removeEventListener('scroll', this.onScroll);
 
//             this.props.myParent.scrollDoneHanlder();

//             window.scrollTo(0, this.myRef.current.offsetTop);

//             console.log("Scroll done");
//         }
//     }

   

//     displayFullImage(name){
//       console.log("displayFullImage " + name);
//     }     
    
//     render(){

//       return (

//         <div className = "prj_body" ref={this.myRef} onScroll={this.onScroll}  >

//           <h1 className = "prj_group_name" >[ generative art ]</h1>
//           <h2 className = "prj_group_description">I'm interested in pattern, noise and form generated by computer algorithm.</h2>
//           <h3 className = "prj_title" >[ SOUND VISUALIZATION ]</h3>
          
//           <div className="prj_grid_container" style = {{gridTemplateColumns: '49% 49%'}}>
            
//             <p className = "prj_description"> The sound is the one of most sensory information for us to recognize 
//                 what's going on the outside world. This audible information is mainly focused on our 
//                 ears to perceive it. Hence, My question is that what happen if we could feel,see and 
//                 touch this invisible energy. I mean how can our brain interpret the sound if the sound 
//                 transformed into other medium. Does it help to listen to a sound? or it interrupts to 
//                 enjoy listen to a sound? In order to do that, I used processing for sound analysis, 
//                 Maya for build 3D object and laser cutter for cutting paper.
//             </p>  

//             <div className = "prj_img">
//               <img  src = {require('./resources/ga_1.JPG')} href={require('./resources/ga_1.JPG')}
//                 onClick ={this.displayFullImage("test")}/>
//               <p>Sound visualization in 3D object</p>
//             </div>
            
//             {/* <img className = "prj_img" src = {require('./resources/ga_1.JPG')}></img>  */}
//             <div className = "prj_img">
//               <img  src = {require('./resources/ga_3.JPG')} />
//               <p>Sound visualization in 3D object</p>
//             </div>

//             <div className = "prj_img">
//               <img  src = {require('./resources/ga_2.JPG')} />
//               <p>Sound visualization made of new papers</p>
//             </div>

//           </div>

//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>
//           <br/>


     
          
//         </div>


//       );
//     }

      
//     // render(){

//     //     return(

//     //         <div className = "prj_body" onScroll={this.onScroll} ref={this.myRef} >
//     //             <h1 className = "prj_group_name">[ generative art ]</h1>
//     //             <h2 className = "prj_group_description">I'm interested in pattern, noise and form generated by computer algorithm.</h2>
//     //             <br/>
//     //             <br/>
//     //             <br/>
//     //             <br/>
//     //             <h3 className = "prj_title" >[ SOUND VISUALIZATION ]</h3>
//     //               <this.splitPane left = {<h1>The sound is the one of most sensory information for us to recognize 
//     //               what's going on the outside world. This audible information is mainly focused on our 
//     //               ears to perceive it. Hence, My question is that what happen if we could feel,see and 
//     //               touch this invisible energy. I mean how can our brain interpret the sound if the sound 
//     //               transformed into other medium. Does it help to listen to a sound? or it interrupts to 
//     //               enjoy listen to a sound? In order to do that, I used processing for sound analysis, 
//     //               Maya for build 3D object and laser cutter for cutting paper.<br/></h1>}
//     //               right = {<img src = {require('./resources/ga_1.JPG')}></img>}>
//     //               </this.splitPane>

//     //               <div className = "divider" />

//     //               <this.splitPane left = {<img src = {require('./resources/ga_3.JPG')}></img>}
//     //               right = {<img src = {require('./resources/ga_2.JPG')}></img>}>
//     //               </this.splitPane>
//     //         </div>
//     //     );
//     // }
// }

// export default GenerativeArt;